import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Text, Button } from "~/components-shared";
const Section = styled.section`
  padding: 4em;

  @media (max-width: 768px) {
    padding: 1em;
  }
`;
const ErrorSection = _ref => {
  let {
    error,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const handleReload = () => {
    history.go(0);
  };
  return /*#__PURE__*/React.createElement(Section, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h1"
  }, t("LoadingError.title")), /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    s: {
      mb: 3
    }
  }, t("LoadingError.subTitle")), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 4,
    weight: "semiBold",
    element: "p"
  }, error), /*#__PURE__*/React.createElement(Button, {
    rounded: true,
    s: {
      mt: 5,
      px: 8,
      py: 3
    },
    onClick: handleReload
  }, t("LoadingError.tryAgain")));
};
export default ErrorSection;